<template>
  <div class="card-item">
    <div class="card-item-body">
      <b-row>
        <b-col>
          <button-toolbar
              :sessions="sessions"
              :doc-status="docStatus"
              @doc-status-click="handleDocStatusClick"
              @search-input="handleSearchInput"
          />
        </b-col>
      </b-row>
      <div class="sessions">
        <data-table
          :sessions="filteredSessions"
          @update-status-click="handleUpdateStatusClick"
        />
      </div>
      <update-status-modal
        :ref="updateStatusModalId"
        :profile="profile"
      />

    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import ButtonToolbar from "./buttonToolbar"
import DataTable from "./dataTable"
import UpdateStatusModal from "./updateStatusModal";

export default {
  name: "Admin_Manage_Sessions",
  components: {
    ButtonToolbar,
    DataTable,
    UpdateStatusModal
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      sessions: "admin/sessions"
    }),
    filteredSessions() {
      let sessions = this.sessionsFilteredByDocStatus(this.sessions, this.docStatus);
      
      //@ToDo: Must consider doc levels - doc and doc_stage
      /*sessions = sessions.filter(aSession => {
        return aSession && aSession.session ?
               (!aSession.session.title || aSession.session.session.title.includes(this.searchStr))
            : false;
      })*/

      return sessions;
    },
  },
  mounted() {},
  methods: {
    handleUpdateStatusClick(sessionData){
      if (this.$refs[this.updateStatusModalId].hasOwnProperty('handleOpenStatusModalForSessionData')){
        this.$refs[this.updateStatusModalId].handleOpenStatusModalForSessionData(sessionData);
      }
    },
    sessionsFilteredByDocStatus(sessions, docStatus) {
      let _sessions =  [];
      if (docStatus === null) {
        _sessions = sessions && Array.isArray(sessions) ? sessions : [];
      }else {

       _sessions = sessions && Array.isArray(sessions) ?
            sessions.filter(aSession => {
              switch (docStatus) {
                case "active":
                  return aSession.hasOwnProperty("status_publish") ?
                      aSession.status_publish === "active" : false;
                case "submitted":
                  return aSession.hasOwnProperty("status_stage") ?
                      aSession.status_stage === "submitted" : false;
                case "need_work":
                  return aSession.hasOwnProperty("status_stage") ?
                      aSession.status_stage === "need_work" : false;
                default:
                  return false;
              }
            }) : [];
      }
      return _sessions;
    },
    handleSearchInput(searchInput){
      debugger;
      this.searchStr = searchInput;
    },
    handleDocStatusClick(status){
      this.docStatus = status;
    },
    handleActivation() {
      this.handleRefreshData();
    },
    totalDocCount(docLevel) {
      return this.sessions && Array.isArray(this.sessions)
        ? this.sessions.filter(aSession => {
            return (
              aSession.hasOwnProperty(docLevel) &&
              aSession[docLevel] !== null
            );
          }).length
        : 0;
    },
    handleRefreshData() {
      this.fetchedSessions = false;
      this.$store
        .dispatch("admin/getSessions")
        .then(resp => {
          this.fetchedSessions = true;
        })
        .finally(data => {
          this.fetchedSessions = true;
        });
    },
    formatDate(date) {
      //TODO- Move to mixin
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    getDate(date) {
      return moment(date).format("DD MMMM");
    },
    editSession(track) {
      this.edit = true;
      this.selectedSessionId = track.id;
      if (track.track && track.track.title) {
        this.modalTitle = track.track.title;
      } else {
        this.modalTitle = track[this.docLevel].title;
      }
      if (track.track && track.track.mins) {
        this.modalMins = track.track.mins;
      }
      if (track.track && track.track.summary) {
        this.modalSummary = track.track.summary;
      }
      if (track.track && track.track.imgURL) {
        this.activeImg = track.track.imgURL;
      }
      if (track.slug) {
        this.modalSlug = track.slug;
      }

    },
    calculateMinutes(summary) {
      let wordsCount = summary.match(/(\w+)/g).length;
      let mins = Math.ceil(wordsCount / 200);
      return mins;
    },
  },
  data() {
    return {
      searchStr: "",
      docStatus: null, //|all | submitted | needs_work | inactive
      docLevel: "doc_stage", //doc, doc_stage //versions, doc_local |all | submitted | needs_work | inactive
      fetchedSessions: false,
      updateStatusModalId:'update-status-modal',
      modalTitle: "",
      modalSlug: "",
      edit: false,
      del: false,
      modalMins: 0,
      modalSummary: "",
      activeImg: null,
      selectedSessionId: null,
      modalStatus: null,
    };
  }
};
</script>

<style lang="scss" scoped>
.add-users {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-user {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-user {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-item {
  box-shadow: none;
}
.sessions {
  margin-top: 20px;
  .ico {
    cursor: pointer;
  }
  .cover-img {
    width: 150px;
  }
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.post {
  cursor: pointer;
  padding: 5px 15px;
  border-bottom: 1px solid #000;
  span {
    font-weight: bold;
  }
}
.active {
  background: rgb(164, 214, 255);
}
.track-images {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.track-image {
  cursor: pointer;
  width: 130px;
  height: 100px;
  border-radius: 10px;
  margin: 10px 15px;
}
.active-image {
  border: 5px solid var(--theme-color);
}
.entry {
  padding: 7px;
  .heading {
    width: 120px;
    margin-right: 15px;
    font-weight: bold;
  }
}
.track {
  display: grid;
  grid-template-columns: 198px 1fr;
  grid-column-gap: 23px;
  margin-bottom: 24px;
  align-items: stretch;
  .img-track {
    width: 198px;
    height: 100%;
    & > div {
      height: 100%;
    }
    img {
      height: 152px;
      width: 100%;
      object-fit: cover;
    }
  }
}
.session-content {
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #52595e;
    margin-bottom: 8px;
  }
  .description {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #8d99a0;
    margin-bottom: 8px;
  }
  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .read-more-btn {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: right;
      color: var(--theme-color);
    }
    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 8px;
      .read {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
  }
  .track-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .author {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 12px;
      img {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      grid-column-gap: 16px;
    }
  }
}
.tools {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
}
.detail-tools {
  width: 370px;
  border: 1px solid #eceff9;
}
.status {
  margin-top: 0.5rem;
  .status-btn {
    display: inline-block;
    margin-right: 15px;
    width: 105px;
    height: 21px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    background: var(--theme-color);
    text-align: center;
    border: none;
    border-radius: 3px;
  }
}

.actions {
  display: flex;
  justify-content: space-evenly;
}
.owner-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.sessions .colWidth {
  max-width: 100px;
}
</style>
